<template>
  <div class="trombinoscope-container">
    <div class="section-details">
      <div class="info-grid_layout">
        <div class="title-counter">
          <h3>{{ Title }}</h3>
          <div class="projectCounter">
            <span class="span projectCounter">Tous les projets ({{ numberOfProject }}) | Projets conservés ({{ filteredProjectsCount }})</span>
          </div>
        </div>
        <div class="grid-layout">
          <Transition name="grid-fade" mode="out-in">
            <div class="grid-layout-container" :key="activeIndex" v-if="!isListView">
              <div
                :class="{'active': activeIndex === index, 'inactive': activeIndex !== index}"
                class="grid-icon-container"
                v-for="(icon, index) in icons"
                :key="index"
              >
                <img
                  @click="changeGrid(index)"
                  :id="`icon-${index}`"
                  class="grid-icon"
                  :src="icon.src"
                  :alt="icon.alt"
                />
              </div>
            </div>
          </Transition>
          <div @click="toggleListView" :class="{'active': isListView}" class="list-icon-container grid-icon-container">
            <svg v-if="isListView" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"><path fill="currentColor" d="M5.5 4h4c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 4 9.5v-4C4 4.67 4.67 4 5.5 4zm9 0h4c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 13 9.5v-4c0-.83.67-1.5 1.5-1.5zm0 9h4c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5v-4c0-.83.67-1.5 1.5-1.5zm-9 0h4c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 4 18.5v-4c0-.83.67-1.5 1.5-1.5zm0-7.5v4h4v-4h-4zm9 0v4h4v-4h-4zm0 9v4h4v-4h-4zm-9 0v4h4v-4h-4z"></path></svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.75 5.25h7.5a.75.75 0 1 1 0 1.5h-7.5a.75.75 0 1 1 0-1.5zm0 6h7.5a.75.75 0 1 1 0 1.5h-7.5a.75.75 0 1 1 0-1.5zm0 6h7.5a.75.75 0 1 1 0 1.5h-7.5a.75.75 0 1 1 0-1.5zM6 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"></path></svg>
          </div>
        </div>
      </div>

      <div class="filter-container">
        <div class="select-container">
          <select id="sort" v-model="sortOption">
            <option value="none" selected>Pas de tri par ordre alphabétique</option>
            <option value="a-z">Trier par ordre alphabétique (A-Z)</option>
            <option value="z-a">Trier par ordre alphabétique (Z-A)</option>
          </select>

          <select id="sort-date" v-model="sortDateOption">
            <option value="none" selected>Pas de tri par date</option>
            <option value="3-months">Derniers 3 mois</option>
            <option value="6-months">Derniers 6 mois</option>
            <option value="1-year">Dernière année</option>
            <option value="2-years">Derniers 2 ans</option>
          </select>

          <select id="sort-order" v-model="sortOrderOption">
            <option value="none" selected>Pas de tri par ordre chronologique</option>
            <option value="chronological">Trier par ordre chronologique</option>
            <option value="reverse-chronological">Trier par ordre antichronologique</option>
          </select>

          <button @click="resetFilters">Réintialiser</button>
        </div>

        <div class="search-container">
          <label for="project-search">
            <form @submit.prevent>
              <input
                type="text"
                placeholder="Rechercher un projet"
                id="project-search"
                v-model="searchQuery"
              >
            </form>
            <Transition mode="out-in" name="cross">
              <div v-if="searchQuery">
                <span class="clear-icon" @click="clearSearch">✖</span>
              </div>
            </Transition>
          </label>
        </div>
      </div>
    </div>

    <Transition mode="out-in" name="banner-appear">
      <div>
        <h2 v-if="sortedProjects.length === 0" class="no-projects-message">
          Aucun projet trouvé correspondant aux critères.
        </h2>
      </div>
    </Transition>

    <!-- Vue grille -->
    <TransitionGroup v-if="!isListView" :style="{gridTemplateColumns:grid}" mode="out-in" name="list" tag="div" class="trombinoscope">
      <router-link
        v-for="(project, index) in sortedProjects"
        :to="`${baseRoute}/${project.nom.toLowerCase().replace(/ /g, '-')}`"
        :key="project.nom"
        :style="{
          backgroundImage: `url(${project.background})`,
          width: activeIndex === 0 ? '50vw' : activeIndex === 1 ? '40vw' : activeIndex === 2 ? '30vw' : '23vw',
          height: activeIndex === 0 ? '50vw' : activeIndex === 1 ? '40vw' : activeIndex === 2 ? '30vw' : '23vw'
        }"
        class="project"
      >
        <Transition mode="out-in" name="banner-appear">
          <div class="project-banner">
            <h3 class="project-name">{{ project.nom }}</h3>
            <div class="right-banner">
              <h1 class="project-number">{{ index + 1 }}</h1>
            </div>
          </div>
        </Transition>
      </router-link>
    </TransitionGroup>

    <!-- Vue liste -->
    <div v-else class="trombinoscope-list">
      <table>
        <thead>
          <tr>
            <th><p>Nom</p></th>
            <th><p>Compétences</p></th>
            <th><p>Date</p></th>
            <th><p>Description</p></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="project in sortedProjects"
  :key="project.nom"
            style="cursor:pointer"
            @click="$router.push(`${baseRoute}/${project.nom.toLowerCase().replace(/ /g, '-')}`)"
          >
            <td>
              <p style="display:flex;align-items:center;gap:1.5rem">
                <img width="80" height="80" :src="project.background">{{ project.nom }}
              </p>
            </td>
            <td>
              <div class="skills">
                <img loading="lazy" v-for="skill in project.skills" :src="'/img/pictogramme/competences/'+skill" :key="`skill-${skill}`" :alt="`Skill: ${skill}`" class="skill-image" />
              </div>
            </td>
            <td>
              <span class="date span"><p>{{ project.date }}</p></span>
            </td>
            <td>
              <p>{{ project.description }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    projects: {
      type: Array,
      required: true,
    },
    Title: {
      type: String,
      required: true
    },
    baseRoute: {
      type: String,
    }
  },
  data() {
    return {
      icons: [
        { src: "/img/pictogramme/grid1.png", alt: "grid-icon-1", grid: "repeat(1, auto)" },
        { src: "/img/pictogramme/grid2.png", alt: "grid-icon-2", grid: "repeat(2, auto)" },
        { src: "/img/pictogramme/grid3.png", alt: "grid-icon-3", grid: "repeat(3, auto)" },
      ],
      grid: "repeat(3, auto)",
      activeIndex: 2,
      numberOfProject: this.projects.length,
      visibleProjectId: null,
      sortByAlphabet: false,
      sortOption: 'none',
      sortDateOption: 'none',
      sortOrderOption: 'none',
      searchQuery: '',
      isListView: false,
    };
  },
  created() {
    const savedIndex = localStorage.getItem("activeIndex");
    const savedGrid = localStorage.getItem("grid");

    if (savedIndex !== null) {
      this.activeIndex = parseInt(savedIndex, 10);
    }
    if (savedGrid) {
      this.grid = savedGrid;
    }
  },
  computed: {
    sortedProjects() {
      let sorted = [...this.projects]; // ✅ simple copie, pas besoin d'id

      // Filtrer par recherche
      if (this.searchQuery) {
        const query = this.normalizeString(this.searchQuery.toLowerCase());
        sorted = sorted.filter(project =>
          this.normalizeString(project.nom.toLowerCase()).includes(query) ||
          this.normalizeString(project.description.toLowerCase()).includes(query)
        );
      }

      // Trier par ordre alphabétique
      if (this.sortOption === 'a-z') {
        sorted.sort((a, b) => a.nom.localeCompare(b.nom));
      } else if (this.sortOption === 'z-a') {
        sorted.sort((a, b) => b.nom.localeCompare(a.nom));
      }

      // Filtrer par date
      const now = new Date();
      if (this.sortDateOption === '3-months') {
        sorted = sorted.filter(project =>
          (now - this.parseDate(project.date)) / (1000 * 60 * 60 * 24) <= 90
        );
      } else if (this.sortDateOption === '6-months') {
        sorted = sorted.filter(project =>
          (now - this.parseDate(project.date)) / (1000 * 60 * 60 * 24) <= 180
        );
      } else if (this.sortDateOption === '1-year') {
        sorted = sorted.filter(project =>
          (now - this.parseDate(project.date)) / (1000 * 60 * 60 * 24) <= 365
        );
      } else if (this.sortDateOption === '2-years') {
        sorted = sorted.filter(project =>
          (now - this.parseDate(project.date)) / (1000 * 60 * 60 * 24) <= 730
        );
      }

      // Trier par ordre chronologique
      if (this.sortOrderOption === 'chronological') {
        sorted.sort((a, b) => this.parseDate(a.date) - this.parseDate(b.date));
      } else if (this.sortOrderOption === 'reverse-chronological') {
        sorted.sort((a, b) => this.parseDate(b.date) - this.parseDate(a.date));
      }

      return sorted;
    },
    filteredProjectsCount() {
      return this.sortedProjects.length;
    },
  },
  mounted() {
    this.loadFiltersFromStorage();
    const savedListView = localStorage.getItem('isListView');
    if (savedListView !== null) {
      this.isListView = savedListView === 'true';
    }
  },
  methods: {
    changeGrid(index) {
      this.activeIndex = index;
      this.grid = this.icons[index].grid;
      localStorage.setItem("activeIndex", index);
      localStorage.setItem("grid", this.grid);
    },
    clearSearch() {
      this.searchQuery = '';
    },
    normalizeString(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    toggleSort() {
      this.sortByAlphabet = !this.sortByAlphabet;
    },
    resetFilters() {
      this.sortOption = 'none';
      this.sortDateOption = 'none';
      this.sortOrderOption = 'none';
      this.searchQuery = '';
      this.saveFiltersToStorage();
    },
    saveFiltersToStorage() {
      const filters = {
        sortOption: this.sortOption,
        sortDateOption: this.sortDateOption,
        sortOrderOption: this.sortOrderOption,
        searchQuery: this.searchQuery,
      };
      localStorage.setItem('projectFilters', JSON.stringify(filters));
    },
    loadFiltersFromStorage() {
      const filters = JSON.parse(localStorage.getItem('projectFilters'));
      if (filters) {
        this.sortOption = filters.sortOption || 'none';
        this.sortDateOption = filters.sortDateOption || 'none';
        this.sortOrderOption = filters.sortOrderOption || 'none';
        this.searchQuery = filters.searchQuery || '';
      }
    },
    parseDate(dateString) {
      if (!dateString || typeof dateString !== 'string') {
        console.error('Invalid date string:', dateString);
        return new Date('Invalid Date');
      }

      const months = {
        janvier: 0, février: 1, mars: 2, avril: 3, mai: 4, juin: 5,
        juillet: 6, août: 7, septembre: 8, octobre: 9, novembre: 10, décembre: 11
      };

      const [monthName, year] = dateString.toLowerCase().split(' ');
      const month = months[monthName];

      if (month !== undefined && year) {
        return new Date(year, month, 1);
      }

      console.error('Failed to parse date:', dateString);
      return new Date('Invalid Date');
    },
    toggleListView() {
      this.isListView = !this.isListView;
      localStorage.setItem('isListView', this.isListView);
    }
  },
  watch: {
    sortOption() { this.saveFiltersToStorage(); },
    sortDateOption() { this.saveFiltersToStorage(); },
    sortOrderOption() { this.saveFiltersToStorage(); },
    searchQuery() { this.saveFiltersToStorage(); },
  },
};
</script>























  <style scoped>

/* CSS TRANSITION */

.grid-fade-enter-active, .grid-fade-leave-active {
  transition: opacity 0.5s cubic-bezier(0.23, 1, 0.32, 1), transform 0.5s cubic-bezier(0.23, 1, 0.32, 1);
}
.grid-fade-enter-from, .grid-fade-leave-to {
  opacity: 0;
  transform: scale(0.85);
}

.banner-appear-enter-active,
.banner-appear-leave-active {
  transition: all 1s cubic-bezier(0.23, 1, 0.320, 1);
}

.banner-appear-enter-from,
.banner-appear-leave-to {
  opacity: 0;
  transform: translateY(100px);
}

.cross-enter-active,
.cross-leave-active {
  transition: all 0.55s cubic-bezier(0.23, 1, 0.320, 1);
}

.cross-enter-from,
.cross-leave-to {
  opacity: 0;
  transform:translateX(20px) rotate(25deg) !important;
}


.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: scale(0.25);
}

.list-move {
  transition: transform 0.75s cubic-bezier(0.785, 0.135, 0.15, 0.86);
}

/* CSS TRANSITION */


.grid-layout .active, .grid-icon-container,.grid-icon-container img,.grid-icon-container svg{
    transition: all 0.55s cubic-bezier(0.23, 1, 0.320, 1);
}

.grid-layout .active{
  background: var(--yellow-white) !important;
  box-shadow: 0px 0px 0px 2px #141428, 0px 0px 0px 4px var(--yellow-white);
}

.grid-layout .active img,.active svg{
  filter: invert(1);
}

.grid-icon-container{
    border-radius: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--hard-blue);
    border:1px solid var(--gray);
    box-shadow: var(--box-shadow-1);
}

.list-icon-container{
    width:3.5rem;
    height:3.5rem;
    margin-left:2rem;
}

.grid-icon{
    width: 3.5rem;
    height: 3.5rem;
    padding: 8px;
}

.info-grid_layout{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.favorite-icon{
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 2rem;
    right: 2rem;
    font-size:4rem;
}

.banner-section {
    color: #333;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
    border-radius: 8px 8px 0 0;
    margin-bottom: 1rem;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    min-height: 15rem;
    background-repeat: no-repeat;
    background-size: 115%;
    background-position: center;
}

.trombinoscope-container{
  display: flex;
  flex-direction: column;
}

h2{
  text-align: center;
  margin:15rem 0;
}

.skills{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap:0.75rem;
  margin-top: 4px;
}

.skill-image{
  width:2rem;
  height:2rem;
}

.date{
  text-wrap: nowrap;
}

.select-container{
  display: flex;
  flex-wrap: wrap;
  gap:2rem;
}

.filter-container{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap:2rem;
  margin-top: 1rem;
}

.right-banner{
  padding:0.5vw;
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.select-container{
  margin:1rem 0;
}

.section-details{
  margin: 2.5rem auto;
  width:100%;
  position: relative;
  background: var(--hard-blue);
  padding: 20px 30px;
  border-radius:0;
  box-shadow: var(--box-shadow-1);
}

.trombinoscope {
    display: grid;
    grid-template-columns: repeat(3,auto);
    width: 100%;
    gap: 1.5vw;
    margin-bottom: 5rem;
    justify-content: center;
}

.project {
    transition:0.5s cubic-bezier(0.785, 0.135, 0.15, 0.86);
    width: 40rem;
    height: 40rem;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position:relative;
    display:grid;
    overflow: hidden;
    box-shadow:var(--box-shadow-1);
    background-color: var(--gray-hover);
}

.project .project-name{
  font-size: 3rem;
  width:60%;
  font-weight: 900;
  line-height: 1;
}

.project .project-banner{
    background: var(--hard-blue);
    padding:.5rem 1rem;
    height: 8vw;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 0;
    width: 100%;
    right: 0;
    box-shadow: -0px -2px 20px 0px rgb(0 0 0 / 15%);
    border-top:1px solid rgba(0, 0, 0, 0.25);
}

.project-number{
  font-family: var(--font-number-title-outlined);
}

.project:hover .project-number{
  font-family: var(--font-number-title);
}

.project-banner,.project-name,.project-number{
  transition: 0.45s cubic-bezier(0.785, 0.135, 0.15, 0.86);
}

.project:hover .project-name{
  color:var(--hard-blue);
}

.project:hover .project-banner{
  background: var(--yellow-white);
}

.project .projectButton{
  position:absolute;
  bottom:3rem;
  right:3rem;
}

label{
  background: var(--yellow-white);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px 5px 0 0;
}

.search-container {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1vw;
}

.search-container input {
  padding-right: 2rem; 
}

.clear-icon {
  position: absolute;
    right: 1rem;
    font-size: 1.6rem;
    transform: translateY(-1.3rem);
    color: #666;
    transition: color 0.3s;
}

.clear-icon:hover {
  color: #000;
}

.grid-layout{
  display: flex;
  gap:2rem;
  justify-content: center;
  align-items: center;
}

.grid-layout-container{
  display: flex;
  gap:2rem;
  justify-content: center;
  align-items: center;
}












@media (max-width: 1000px) {
  .trombinoscope{
    grid-template-columns: repeat(2,auto) !important;
  }
.project{
  width: 47vw !important;
  height: 47vw !important;
}
.grid-layout{
  display: none;
}
}

@media (max-width: 600px) {
  .trombinoscope{
    grid-template-columns: repeat(1,auto) !important;
  }
.project{
  width: 90vw !important;
  height: 90vw !important;
}
.project-name{
  font-size: 4.5rem !important;
}
}

@media (max-width: 800px) {
.project-name{
  font-size: 3.25rem !important;
}
.project-number{
  font-size: 8rem;
}
.project-banner{
  height: auto !important;
}
}

@media (max-width:1024px) {
  .trombinoscope{
    gap:15px;
  }
}
















table p img{
  object-fit: cover;
  box-shadow: var(--box-shadow-1);
  border-radius: 6px;
}

.trombinoscope-list {
   width: 100%;
  margin-top: 2rem;
  /* Ajoute ceci pour centrer le contenu si besoin */
  display: flex;
  flex-direction: column;
  align-items: stretch;
  
}

.trombinoscope-list tr{
  transition:all 0.35s cubic-bezier(0.785, 0.135, 0.15, 0.86);
}

.trombinoscope-list table {
  width: 97%;
  border-collapse: collapse;
  margin: 2rem auto;
  overflow: hidden;
  /* Ajoute ceci pour forcer la largeur */
  table-layout: fixed;
}

.trombinoscope-list th, .trombinoscope-list td {
  padding: 2rem 1rem;
  border-bottom: 1px solid var(--gray-hover-1);
  text-align: left;
  vertical-align: middle;
}

tr th{
  padding:1.25rem 1rem !important;
}

.trombinoscope-list tr:hover {
  background-color: var(--gray-hover-1);
}

.trombinoscope-list th {
  font-weight: bold;
}

.trombinoscope-list tr:last-child td {
  border-bottom: none;
}

.trombinoscope-list .skills {
  gap: 0.25rem;
  flex-wrap: wrap;
  justify-content: flex-start !important;
}

.trombinoscope-list .skill-image {
  width: 2.5rem;
  height: 2.5rem;
  object-fit: contain;
}


@media (max-width: 600px) {
  .trombinoscope-list th,
  .trombinoscope-list td {
    padding: 0.75rem;
    font-size: 0.9rem;
  }

  .trombinoscope-list th {
    display: none; /* Cacher les en-têtes sur mobile */
  }

  .trombinoscope-list tr {
    display: block;
    margin-bottom: 1rem;
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
  }

  .trombinoscope-list td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
    border: none;
  }

  .trombinoscope-list td.router-link-active {
    background-color: rgba(0, 0, 0, 0.1);
  }
}

</style>








